import { api, queryKeys, tokenManager } from './client';
import type {
	LoginRequest,
	LoginResponse,
	AuthMeResponse,
	TokenRefreshResponse,
} from '../types/auth.types';

/**
 * Login user with email and password
 */
export async function login(credentials: LoginRequest): Promise<LoginResponse> {
	const response = await api.post<LoginResponse>('/v1/auth/login', credentials);
	return response.data;
}

/**
 * Logout user - clears tokens and notifies backend
 */
export async function logout(): Promise<void> {
	try {
		await api.post('/v1/auth/logout');
	} finally {
		tokenManager.clearTokens();
	}
}

/**
 * Get current authenticated user info and permissions
 */
export async function getAuthMe(): Promise<AuthMeResponse> {
	const response = await api.get<AuthMeResponse>('/v1/auth/me');
	return response.data;
}

/**
 * Refresh access token
 * This is called automatically by the API client interceptor
 */
export async function refreshToken(refreshToken: string): Promise<TokenRefreshResponse> {
	const response = await api.post<TokenRefreshResponse>('/v1/auth/refresh', {
		refreshToken,
	});
	return response.data;
}

/**
 * Query keys for auth
 */
export const authKeys = {
	me: () => queryKeys.auth.me(),
	user: () => queryKeys.auth.user(),
	session: () => queryKeys.auth.session(),
};
